module.exports = __webpack_public_path__ + "img/Banner-teleport.60e572a6.jpeg";